import { render } from "./AssignPermisosModal.vue?vue&type=template&id=567b89c6"
import script from "./AssignPermisosModal.vue?vue&type=script&lang=js"
export * from "./AssignPermisosModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__